import { Component, OnInit } from '@angular/core';
import { EventService } from './services/event.service';
import { Event } from './modules/event';

@Component({
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  public countries: string[] = [];
  public tags: string[] = [];
  public events: Event[] = [];

  constructor(
    private eventService: EventService
  ) { }

  async ngOnInit() {
    [this.countries, this.tags] = await this.eventService.getFilter();
    this.events = await this.eventService.getEvents('');
  }

  async updateFilter(newFilter: string) {
    this.events = await this.eventService.getEvents(newFilter);
    if ((newFilter.includes('date') || newFilter.includes('country') || newFilter == '')) {
      this.tags = await this.eventService.getTags(newFilter.split('&tags')[0]);
    }
  }

}
